import type { ChainJointsSlice, ChainJointsState, ViewerSliceCreator } from "./types";

export const chainJointsInitialState: ChainJointsState = {
  chainJointsResult: null,
};

export const createChainJointsSlice: ViewerSliceCreator<ChainJointsSlice> = (set) => ({
  ...chainJointsInitialState,

  setChainJointsResult: (msg) =>
    set((state) => {
      state.chainJointsResult = {
        baseLink: msg.base_link,
        tipLink: msg.tip_link,
        jointNames: msg.joint_names,
        success: msg.success,
        error: msg.error,
      };
    }),

  clearChainJointsResult: () =>
    set((state) => {
      state.chainJointsResult = null;
    }),
});
